import {
  areaDataByCondition,
  getHotCity,
  getSearchCond,
  initUrlQuery,
  searchAll,
} from "api/jjzq"
import { modifyCondition, toServerParam } from "comps/Jjzq"
import { allSettled } from "libs/utils"
import { GetServerSideProps } from "next"
import JjzqIndex from "views/JjzqIndex"

export default function PageIndex(props: any) {
  return <JjzqIndex {...props} />
}

export const getServerSideProps: GetServerSideProps = async (ctx: any) => {
  let res: any = await getData(ctx)

  return {
    props: {
      ...res,
    },
  }
}

export const typeMap = {
  "1": 115,
  "2": 116,
}
export async function getData(ctx) {
  const serverHeaders = ctx.req.headers
  const { type = "1" }: JjzqQueryObj = ctx.req.query
  let res: any = {
    condition: {},
    hotAreas: [],
    otherAreas: [],
    mainSSData: {},
  }
  const [searchCond, hotAreas, otherAreas, mainSSData] = await allSettled([
    getSearchCond({
      serverSide: true,
      headers: serverHeaders,
      query: {
        type: typeMap[type],
      },
    }),
    getHotCity({
      serverSide: true,
      headers: serverHeaders,
    }),
    areaDataByCondition({
      serverSide: true,
      headers: serverHeaders,
      query: {
        level: 1,
      },
    }),
    searchAll({
      serverSide: true,
      headers: serverHeaders,
      json: toServerParam(ctx.req.query, initUrlQuery.pageSize, true),
      method: "POST",
    }),
  ])
  if (searchCond?.data?.code === 200) {
    res.condition = searchCond.data.data || {}
    res.condition.categories = modifyCondition(
      res.condition.categories ?? [],
      1,
    )
  }
  if (hotAreas?.data?.code === 200) {
    res.hotAreas = hotAreas.data.data.hotAreas
  }
  if (otherAreas?.data?.code === 200) {
    res.otherAreas = otherAreas.data.data
  }
  if (mainSSData?.data?.code === 200) {
    res.mainSSData = mainSSData.data.data
  }
  return res
}
